module.exports = __webpack_public_path__ + "img/Whatsapp.a93db514.png";